import useGtmPushEvent from "shared/hooks/useGtmPushEvent";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function GtmPageViewTracker(props = {}) {
  const pushEvent = useGtmPushEvent(props);
  const location = useLocation();
  const previousPath = useRef(null);
  useEffect(() => {
    const currentPath = location.pathname + location.search;
    // Prevent duplicate firing
    if (previousPath.current === currentPath) return;
    previousPath.current = currentPath;
    pushEvent({
      event: "pageview",
      page_path: currentPath,
    });
  }, [location]);
  return null;
}
